// extracted by mini-css-extract-plugin
export var aircallIframe = "_kx-3";
export var fabContainer = "_kx-5";
export var fabRinging = "_kx-6";
export var loadingOverlay = "_kx-4";
export var pulse = "_kx-7";
export var widgetContent = "_kx-2";
export var widgetPanel = "_kx-0";
export var widgetPanelExpanded = "_kx-1";